import React from 'react'

const Integration = () => {
  return (
    <div>
      <p>Integration</p>
    </div>
  )
}

export default Integration
